import './App.css'
import './index.css'

import { useAuth } from './teacher/AuthContext'; // adjust path to your AuthContext file if needed
import { Navigate, Outlet } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import  Home  from './pages/home'
import  Prekindergartengrade_k0  from './learning/california/prekindergartengrade_k0.jsx'
import Prekindergartengrade_k0math from './learning/california/prekindergartengrade_k0math.jsx';
import Prekindergartengrade_k0eng from './learning/california/prekindergartengrade_k0eng.jsx';
import Prekindergartengrade_k0scie from './learning/california/prekindergartengrade_k0scie.jsx';
import Prekindergartengrade_k0soc from './learning/california/prekindergartengrade_k0soc.jsx';
import  Kindergartengrade_k  from './learning/california/kindergartengrade_k.jsx'
import Kindergartengrade_kmath from './learning/california/kindergartengrade_kmath.jsx';
import Kindergartengrade_keng from './learning/california/kindergartengrade_keng.jsx';
import Kindergartengrade_kscie from './learning/california/kindergartengrade_kscie.jsx';
import Kindergartengrade_ksoc from './learning/california/kindergartengrade_ksoc.jsx';
import  Firstgrade_k1 from './learning/california/firstgrade_k1.jsx'
import Firstgrade_k1math from './learning/california/firstgrade_k1math.jsx';
import Firstgrade_k1eng from './learning/california/firstgrade_k1eng.jsx';
import Firstgrade_k1scie from './learning/california/firstgrade_k1scie.jsx';
import Firstgrade_k1soc from './learning/california/firstgrade_k1soc.jsx';
import  Secondgrade_k2  from './learning/california/secondgrade_k2.jsx'
import Secondgrade_k2math from './learning/california/secondgrade_k2math.jsx';
import Secondgrade_k2eng from './learning/california/secondgrade_k2eng.jsx';
import Secondgrade_k2scie from './learning/california/secondgrade_k2scie.jsx';
import Secondgrade_k2soc from './learning/california/secondgrade_k2soc.jsx';
import  Thirdgrade_k3  from './learning/california/thirdgrade_k3.jsx'
import Thirdgrade_k3math from './learning/california/thirdgrade_k3math.jsx';
import Thirdgrade_k3eng from './learning/california/thirdgrade_k3eng.jsx';
import Thirdgrade_k3scie from './learning/california/thirdgrade_k3scie.jsx';
import Thirdgrade_k3soc from './learning/california/thirdgrade_k3soc.jsx';
import  Fourthgrade_k4  from './learning/california/fourthgrade_k4.jsx'
import Fourthgrade_k4math from './learning/california/fourthgrade_k4math.jsx';
import Fourthgrade_k4eng from './learning/california/fourthgrade_k4eng.jsx';
import Fourthgrade_k4scie from './learning/california/fourthgrade_k4scie.jsx';
import Fourthgrade_k4soc from './learning/california/fourthgrade_k4soc.jsx';
import  Fifthgrade_k5  from './learning/california/fifthgrade_k5.jsx'
import Fifthgrade_k5math from './learning/california/fifthgrade_k5math.jsx';
import Fifthgrade_k5eng from './learning/california/fifthgrade_k5eng.jsx';
import Fifthgrade_k5scie from './learning/california/fifthgrade_k5scie.jsx';
import Fifthgrade_k5soc from './learning/california/fifthgrade_k5soc.jsx';
import  Sixthgrade_k6  from './learning/california/sixthgrade_k6.jsx'
import Sixthgrade_k6math from './learning/california/sixthgrade_k6math.jsx';
import Sixthgrade_k6eng from './learning/california/sixthgrade_k6eng.jsx';
import Sixthgrade_k6scie from './learning/california/sixthgrade_k6scie.jsx';
import Sixthgrade_k6soc from './learning/california/sixthgrade_k6soc.jsx';
import  Seventhgrade_k7   from './learning/california/seventhgrade_k7.jsx'
import Seventhgrade_k7math from './learning/california/seventhgrade_k7math.jsx';
import Seventhgrade_k7eng from './learning/california/seventhgrade_k7eng.jsx';
import Seventhgrade_k7scie from './learning/california/seventhgrade_k7scie.jsx';
import Seventhgrade_k7soc from './learning/california/seventhgrade_k7soc.jsx';
import  Eighthgrade_k8  from './learning/california/eighthgrade_k8.jsx'
import Eighthgrade_k8math from './learning/california/eighthgrade_k8math.jsx';
import Eighthgrade_k8eng from './learning/california/eighthgrade_k8eng.jsx';
import Eighthgrade_k8scie from './learning/california/eighthgrade_k8scie.jsx';
import Eighthgrade_k8soc from './learning/california/eighthgrade_k8soc.jsx';
import  Ninethgrade_k9  from './learning/california/ninethgrade_k9.jsx'
import Ninethgrade_k9math from './learning/california/eighthgrade_k8math.jsx';
import Ninethgrade_k9eng from './learning/california/eighthgrade_k8eng.jsx';
import Ninethgrade_k9scie from './learning/california/eighthgrade_k8scie.jsx';
import Ninethgrade_k9soc from './learning/california/eighthgrade_k8soc.jsx';
import  Tenthgrade_k10  from './learning/california/tenthgrade_k10.jsx'
import Tenthgrade_k10math from './learning/california/tenthgrade_k10math.jsx';
import Tenthgrade_k10eng from './learning/california/tenthgrade_k10eng.jsx';
import Tenthgrade_k10scie from './learning/california/tenthgrade_k10scie.jsx';
import Tenthgrade_k10soc from './learning/california/tenthgrade_k10soc.jsx';
import  Eleventhgrade_k11  from './learning/california/eleventhgrade_k11.jsx'
import Eleventhgrade_k11math from './learning/california/eleventhgrade_k11math.jsx';
import Eleventhgrade_k11eng from './learning/california/eleventhgrade_k11eng.jsx';
import Eleventhgrade_k11scie from './learning/california/eleventhgrade_k11scie.jsx';
import Eleventhgrade_k11soc from './learning/california/eleventhgrade_k11soc.jsx';
import  Twelvethgrade_k12  from './learning/california/twelvethgrade_k12.jsx'
import Twelvethgrade_k12math from './learning/california/twelvethgrade_k12math.jsx';
import Twelvethgrade_k12eng from './learning/california/twelvethgrade_k12eng.jsx';
import Twelvethgrade_k12scie from './learning/california/twelvethgrade_k12scie.jsx';
import Twelvethgrade_k12soc from './learning/california/twelvethgrade_k12soc.jsx';
import  Independentlearning_k13  from './learning/california/independentlearning_k13.jsx'
import  Independentlearning_k13math  from './learning/california/independentlearning_k13math.jsx'
import  Independentlearning_k13eng  from './learning/california/independentlearning_k13eng.jsx'
import  Independentlearning_k13scie  from './learning/california/independentlearning_k13scie.jsx'
import  Independentlearning_k13soc  from './learning/california/independentlearning_k13soc.jsx'


import  Uganda  from './international/uganda/uganda.jsx'
import   Layout   from './components/Layout.jsx'
import  Threedots  from './components/threedots.jsx'
import References from './components/references.jsx'
import Learning from './learning/learning.jsx'
import Assessment from './teacher/assessment.jsx'

import Feedback from './components/feedback.jsx'
import International from './international/international.jsx'
import Teachers from './teacher/tutoring.jsx'
import Futurize from './components/futurize.jsx'
import Join from './components/join.jsx'
import Assessors from './components/assessors.jsx'
import Podcast from './footer/podcast.jsx'
import Blog from './footer/blog.jsx'
import Logo from './components/logo.jsx'
import { EllipsisVertical } from 'lucide-react';
import  LoginPopup  from './components/LoginPopup.jsx'
import Uganda_baby1 from './international/uganda/uganda_baby1';
import Uganda_baby1math from './international/uganda/uganda_baby1math';
import Uganda_baby1eng from './international/uganda/uganda_baby1eng';
import Uganda_baby1scie from './international/uganda/uganda_baby1scie';
import Uganda_baby1soc from './international/uganda/uganda_baby1soc';

import Uganda_baby2 from './international/uganda/uganda_baby2.jsx'
import Uganda_baby2math from './international/uganda/uganda_baby2math';
import Uganda_baby2eng from './international/uganda/uganda_baby2eng';
import Uganda_baby2scie from './international/uganda/uganda_baby2scie';
import Uganda_baby2soc from './international/uganda/uganda_baby2soc';

import Uganda_baby3 from './international/uganda/uganda_baby3.jsx'
import Uganda_baby3math from './international/uganda/uganda_baby3math';
import Uganda_baby3eng from './international/uganda/uganda_baby3eng';
import Uganda_baby3scie from './international/uganda/uganda_baby3scie';
import Uganda_baby3soc from './international/uganda/uganda_baby3soc';

import Uganda_p1 from './international/uganda/uganda_p1.jsx'
import Uganda_p1math from './international/uganda/uganda_p1math.jsx';
import Uganda_p1eng from './international/uganda/uganda_p1eng.jsx';
import Uganda_p1scie from './international/uganda/uganda_p1scie.jsx';
import Uganda_p1soc from './international/uganda/uganda_p1soc.jsx';

import Uganda_p2 from './international/uganda/uganda_p2.jsx'
import Uganda_p2math from './international/uganda/uganda_p2math.jsx';
import Uganda_p2eng from './international/uganda/uganda_p2eng.jsx';
import Uganda_p2scie from './international/uganda/uganda_p2scie.jsx';
import Uganda_p2soc from './international/uganda/uganda_p2soc.jsx';

import Uganda_p3 from './international/uganda/uganda_p3.jsx'
import Uganda_p3math from './international/uganda/uganda_p3math.jsx';
import Uganda_p3eng from './international/uganda/uganda_p3eng.jsx';
import Uganda_p3scie from './international/uganda/uganda_p3scie.jsx';
import Uganda_p3soc from './international/uganda/uganda_p3soc.jsx';

import Uganda_p4 from './international/uganda/uganda_p4.jsx'
import Uganda_p4math from './international/uganda/uganda_p4math.jsx';
import Uganda_p4eng from './international/uganda/uganda_p4eng.jsx';
import Uganda_p4scie from './international/uganda/uganda_p4scie.jsx';
import Uganda_p4soc from './international/uganda/uganda_p4soc.jsx';

import Uganda_p5 from './international/uganda/uganda_p5.jsx'
import Uganda_p5math from './international/uganda/uganda_p5math.jsx';
import Uganda_p5eng from './international/uganda/uganda_p5eng.jsx';
import Uganda_p5scie from './international/uganda/uganda_p5scie.jsx';
import Uganda_p5soc from './international/uganda/uganda_p5soc.jsx';

import Uganda_p6 from './international/uganda/uganda_p6.jsx'
import Uganda_p6math from './international/uganda/uganda_p6math.jsx';
import Uganda_p6math_elements from './international/uganda/uganda_p6math_elements.jsx'
import Uganda_p6math_topics from './international/uganda/uganda_p6math_topics.jsx'
import Uganda_p6math_form_subsets from './international/uganda/uganda_p6math_form_subsets.jsx'
import Uganda_p6math_form_equal_sets from './international/uganda/uganda_p6math_form_equal_sets.jsx'
import Uganda_p6math_form_complement_of_sets from './international/uganda/uganda_p6math_form_complement_of_sets.jsx'
import Uganda_p6eng from './international/uganda/uganda_p6eng.jsx';
import Uganda_p6scie from './international/uganda/uganda_p6scie.jsx';
import Uganda_p6soc from './international/uganda/uganda_p6soc.jsx';

import Uganda_p7 from './international/uganda/uganda_p7.jsx'
import Uganda_p7math from './international/uganda/uganda_p7math.jsx';
import Uganda_p7eng from './international/uganda/uganda_p7eng.jsx';
import Uganda_p7scie from './international/uganda/uganda_p7scie.jsx';
import Uganda_p7soc from './international/uganda/uganda_p7soc.jsx';

import Uganda_s1 from './international/uganda/uganda_s1.jsx'
import Uganda_s1agr from './international/uganda/uganda_s1agr.jsx'
import Uganda_s1bio from './international/uganda/uganda_s1bio.jsx'
import Uganda_s1che from './international/uganda/uganda_s1che.jsx'
import Uganda_s1cre from './international/uganda/uganda_s1cre.jsx'
import Uganda_s1eng from './international/uganda/uganda_s1eng.jsx'
import Uganda_s1ent from './international/uganda/uganda_s1ent.jsx'
import Uganda_s1fin from './international/uganda/uganda_s1fin.jsx'
import Uganda_s1gen from './international/uganda/uganda_s1gen.jsx'
import Uganda_s1geo from './international/uganda/uganda_s1geo.jsx'
import Uganda_s1his from './international/uganda/uganda_s1his.jsx'
import Uganda_s1inf from './international/uganda/uganda_s1inf.jsx'
import Uganda_s1ire from './international/uganda/uganda_s1ire.jsx'
import Uganda_s1kis from './international/uganda/uganda_s1kis.jsx'
import Uganda_s1lit from './international/uganda/uganda_s1lit.jsx'
import Uganda_s1math from './international/uganda/uganda_s1math.jsx'
import Uganda_s1nut from './international/uganda/uganda_s1nut.jsx'
import Uganda_s1ped from './international/uganda/uganda_s1ped.jsx'
import Uganda_s1per from './international/uganda/uganda_s1per.jsx'
import Uganda_s1phy from './international/uganda/uganda_s1phy.jsx'
import Uganda_s1tec from './international/uganda/uganda_s1tec.jsx'
import Uganda_s1fre from './international/uganda/uganda_s1fre.jsx'
import Uganda_s1ara from './international/uganda/uganda_s1ara.jsx'
import Uganda_s1ger from './international/uganda/uganda_s1ger.jsx'
import Uganda_s1lat from './international/uganda/uganda_s1lat.jsx'
import Uganda_s1chi from './international/uganda/uganda_s1chi.jsx'
import Uganda_s1lug from './international/uganda/uganda_s1lug.jsx'
import Uganda_s1lus from './international/uganda/uganda_s1lus.jsx'

import Uganda_s2 from './international/uganda/uganda_s2.jsx'
import Uganda_s2agr from './international/uganda/uganda_s2agr.jsx'
import Uganda_s2bio from './international/uganda/uganda_s2bio.jsx'
import Uganda_s2che from './international/uganda/uganda_s2che.jsx'
import Uganda_s2cre from './international/uganda/uganda_s2cre.jsx'
import Uganda_s2eng from './international/uganda/uganda_s2eng.jsx'
import Uganda_s2ent from './international/uganda/uganda_s2ent.jsx'
import Uganda_s2fin from './international/uganda/uganda_s2fin.jsx'
import Uganda_s2gen from './international/uganda/uganda_s2gen.jsx'
import Uganda_s2geo from './international/uganda/uganda_s2geo.jsx'
import Uganda_s2his from './international/uganda/uganda_s2his.jsx'
import Uganda_s2inf from './international/uganda/uganda_s2inf.jsx'
import Uganda_s2ire from './international/uganda/uganda_s2ire.jsx'
import Uganda_s2kis from './international/uganda/uganda_s2kis.jsx'
import Uganda_s2lit from './international/uganda/uganda_s2lit.jsx'
import Uganda_s2math from './international/uganda/uganda_s2math.jsx'
import Uganda_s2nut from './international/uganda/uganda_s2nut.jsx'
import Uganda_s2ped from './international/uganda/uganda_s2ped.jsx'
import Uganda_s2per from './international/uganda/uganda_s2per.jsx'
import Uganda_s2phy from './international/uganda/uganda_s2phy.jsx'
import Uganda_s2tec from './international/uganda/uganda_s2tec.jsx'

import Uganda_s2fre from './international/uganda/uganda_s2fre.jsx'
import Uganda_s2ara from './international/uganda/uganda_s2ara.jsx'
import Uganda_s2ger from './international/uganda/uganda_s2ger.jsx'
import Uganda_s2lat from './international/uganda/uganda_s2lat.jsx'
import Uganda_s2chi from './international/uganda/uganda_s2chi.jsx'
import Uganda_s2lug from './international/uganda/uganda_s2lug.jsx'
import Uganda_s2lus from './international/uganda/uganda_s2lus.jsx'

import Uganda_s3 from './international/uganda/uganda_s3.jsx'
import Uganda_s3agr from './international/uganda/uganda_s3agr.jsx'
import Uganda_s3bio from './international/uganda/uganda_s3bio.jsx'
import Uganda_s3che from './international/uganda/uganda_s3che.jsx'
import Uganda_s3cre from './international/uganda/uganda_s3cre.jsx'
import Uganda_s3eng from './international/uganda/uganda_s3eng.jsx'
import Uganda_s3ent from './international/uganda/uganda_s3ent.jsx'
import Uganda_s3fin from './international/uganda/uganda_s3fin.jsx'
import Uganda_s3gen from './international/uganda/uganda_s3gen.jsx'
import Uganda_s3geo from './international/uganda/uganda_s3geo.jsx'
import Uganda_s3his from './international/uganda/uganda_s3his.jsx'
import Uganda_s3inf from './international/uganda/uganda_s3inf.jsx'
import Uganda_s3ire from './international/uganda/uganda_s3ire.jsx'
import Uganda_s3kis from './international/uganda/uganda_s3kis.jsx'
import Uganda_s3lit from './international/uganda/uganda_s3lit.jsx'
import Uganda_s3math from './international/uganda/uganda_s3math.jsx'
import Uganda_s3nut from './international/uganda/uganda_s3nut.jsx'
import Uganda_s3ped from './international/uganda/uganda_s3ped.jsx'
import Uganda_s3per from './international/uganda/uganda_s3per.jsx'
import Uganda_s3phy from './international/uganda/uganda_s3phy.jsx'
import Uganda_s3tec from './international/uganda/uganda_s3tec.jsx'

import Uganda_s3fre from './international/uganda/uganda_s3fre.jsx'
import Uganda_s3ara from './international/uganda/uganda_s3ara.jsx'
import Uganda_s3ger from './international/uganda/uganda_s3ger.jsx'
import Uganda_s3lat from './international/uganda/uganda_s3lat.jsx'
import Uganda_s3chi from './international/uganda/uganda_s3chi.jsx'
import Uganda_s3lug from './international/uganda/uganda_s3lug.jsx'
import Uganda_s3lus from './international/uganda/uganda_s3lus.jsx'


import Uganda_s4 from './international/uganda/uganda_s4.jsx'
import Uganda_s4agr from './international/uganda/uganda_s4agr.jsx'
import Uganda_s4bio from './international/uganda/uganda_s4bio.jsx'
import Uganda_s4che from './international/uganda/uganda_s4che.jsx'
import Uganda_s4cre from './international/uganda/uganda_s4cre.jsx'
import Uganda_s4eng from './international/uganda/uganda_s4eng.jsx'
import Uganda_s4ent from './international/uganda/uganda_s4ent.jsx'
import Uganda_s4fin from './international/uganda/uganda_s4fin.jsx'
import Uganda_s4gen from './international/uganda/uganda_s4gen.jsx'
import Uganda_s4geo from './international/uganda/uganda_s4geo.jsx'
import Uganda_s4his from './international/uganda/uganda_s4his.jsx'
import Uganda_s4inf from './international/uganda/uganda_s4inf.jsx'
import Uganda_s4ire from './international/uganda/uganda_s4ire.jsx'
import Uganda_s4kis from './international/uganda/uganda_s4kis.jsx'
import Uganda_s4lit from './international/uganda/uganda_s4lit.jsx'
import Uganda_s4math from './international/uganda/uganda_s4math.jsx'
import Uganda_s4nut from './international/uganda/uganda_s4nut.jsx'
import Uganda_s4ped from './international/uganda/uganda_s4ped.jsx'
import Uganda_s4per from './international/uganda/uganda_s4per.jsx'
import Uganda_s4phy from './international/uganda/uganda_s4phy.jsx'
import Uganda_s4tec from './international/uganda/uganda_s4tec.jsx'

import Uganda_s4fre from './international/uganda/uganda_s4fre.jsx'
import Uganda_s4ara from './international/uganda/uganda_s4ara.jsx'
import Uganda_s4ger from './international/uganda/uganda_s4ger.jsx'
import Uganda_s4lat from './international/uganda/uganda_s4lat.jsx'
import Uganda_s4chi from './international/uganda/uganda_s4chi.jsx'
import Uganda_s4lug from './international/uganda/uganda_s4lug.jsx'
import Uganda_s4lus from './international/uganda/uganda_s4lus.jsx'

import Uganda_s5 from './international/uganda/uganda_s5.jsx'
import Uganda_s5agr from './international/uganda/uganda_s5agr.jsx'
import Uganda_s5bio from './international/uganda/uganda_s5bio.jsx'
import Uganda_s5che from './international/uganda/uganda_s5che.jsx'
import Uganda_s5cre from './international/uganda/uganda_s5cre.jsx'
import Uganda_s5eco from './international/uganda/uganda_s5eco.jsx'
import Uganda_s5ent from './international/uganda/uganda_s5ent.jsx'
import Uganda_s5fin from './international/uganda/uganda_s5fin.jsx'
import Uganda_s5gep from './international/uganda/uganda_s5gep.jsx'
import Uganda_s5geo from './international/uganda/uganda_s5geo.jsx'
import Uganda_s5his from './international/uganda/uganda_s5his.jsx'
import Uganda_s5ire from './international/uganda/uganda_s5ire.jsx'
import Uganda_s5kis from './international/uganda/uganda_s5kis.jsx'
import Uganda_s5lit from './international/uganda/uganda_s5lit.jsx'
import Uganda_s5math from './international/uganda/uganda_s5math.jsx'
import Uganda_s5nut from './international/uganda/uganda_s5nut.jsx'
import Uganda_s5ped from './international/uganda/uganda_s5ped.jsx'
import Uganda_s5per from './international/uganda/uganda_s5per.jsx'
import Uganda_s5phy from './international/uganda/uganda_s5phy.jsx'
import Uganda_s5scom from './international/uganda/uganda_s5scom.jsx'
import Uganda_s5smath from './international/uganda/uganda_s5smath.jsx'
import Uganda_s5tec from './international/uganda/uganda_s5tec.jsx'

import Uganda_s5fre from './international/uganda/uganda_s5fre.jsx'
import Uganda_s5ara from './international/uganda/uganda_s5ara.jsx'
import Uganda_s5ger from './international/uganda/uganda_s5ger.jsx'
import Uganda_s5lat from './international/uganda/uganda_s5lat.jsx'
import Uganda_s5chi from './international/uganda/uganda_s5chi.jsx'
import Uganda_s5lug from './international/uganda/uganda_s5lug.jsx'
import Uganda_s5lus from './international/uganda/uganda_s5lus.jsx'

import Uganda_s6 from './international/uganda/uganda_s6.jsx'
import Uganda_s6agr from './international/uganda/uganda_s6agr.jsx'
import Uganda_s6bio from './international/uganda/uganda_s6bio.jsx'
import Uganda_s6che from './international/uganda/uganda_s6che.jsx'
import Uganda_s6cre from './international/uganda/uganda_s6cre.jsx'
import Uganda_s6eco from './international/uganda/uganda_s6eco.jsx'
import Uganda_s6ent from './international/uganda/uganda_s6ent.jsx'
import Uganda_s6fin from './international/uganda/uganda_s6fin.jsx'
import Uganda_s6gep from './international/uganda/uganda_s6gep.jsx'
import Uganda_s6geo from './international/uganda/uganda_s6geo.jsx'
import Uganda_s6his from './international/uganda/uganda_s6his.jsx'
import Uganda_s6ire from './international/uganda/uganda_s6ire.jsx'
import Uganda_s6kis from './international/uganda/uganda_s6kis.jsx'
import Uganda_s6lit from './international/uganda/uganda_s6lit.jsx'
import Uganda_s6math from './international/uganda/uganda_s6math.jsx'
import Uganda_s6nut from './international/uganda/uganda_s6nut.jsx'
import Uganda_s6ped from './international/uganda/uganda_s6ped.jsx'
import Uganda_s6per from './international/uganda/uganda_s6per.jsx'
import Uganda_s6phy from './international/uganda/uganda_s6phy.jsx'
import Uganda_s6scom from './international/uganda/uganda_s6scom.jsx'
import Uganda_s6smath from './international/uganda/uganda_s6smath.jsx'
import Uganda_s6tec from './international/uganda/uganda_s6tec.jsx'

import Uganda_s6fre from './international/uganda/uganda_s6fre.jsx'
import Uganda_s6ara from './international/uganda/uganda_s6ara.jsx'
import Uganda_s6ger from './international/uganda/uganda_s6ger.jsx'
import Uganda_s6lat from './international/uganda/uganda_s6lat.jsx'
import Uganda_s6chi from './international/uganda/uganda_s6chi.jsx'
import Uganda_s6lug from './international/uganda/uganda_s6lug.jsx'
import Uganda_s6lus from './international/uganda/uganda_s6lus.jsx'
import Testimony from './footer/testimony.jsx'
import Careers from './footer/careers.jsx'
import Company from './footer/company.jsx'
import Contact from './footer/contact.jsx'
import Faq from './footer/faq.jsx'
import Interpret from './footer/interpret.jsx'
import Privacy from './footer/privacy.jsx'
import Support from './footer/support.jsx'
import Terms from './footer/terms.jsx'
import Advice from './footer/advice.jsx'

import How from './teacher/how.jsx'
import Zambia from './international/zambia.jsx'
import Southafrica from './international/southafrica.jsx'
import Nigeria from './international/nigeria.jsx'
import Australia from './international/australia.jsx'
import Kenya from './international/kenya.jsx'
import Canada from './international/canada.jsx'
import California from './learning/california/california.jsx'
import Alabama from './learning/alabama.jsx'
import Alaska from './learning/alaska.jsx'
import Arizona from './learning/arizona.jsx'
import Arkansas from './learning/arkansas.jsx'
import Colorado from './learning/colorado.jsx'
import Connecticut from './learning/connecticut.jsx'
import Delaware from './learning/delaware.jsx'
import Florida from './learning/florida.jsx'
import Georgia from './learning/georgia.jsx'
import Hawaii from './learning/hawaii.jsx'
import Idaho from './learning/idaho.jsx'
import Illinois from './learning/illinois.jsx'
import Indiana from './learning/indiana.jsx'
import Iowa from './learning/iowa.jsx'
import Wyoming from './learning/wyoming.jsx'
import Wisconsin from './learning/wisconsin.jsx'
import Westvirginia from './learning/westvirginia.jsx'
import Washington from './learning/washington.jsx'
import Virginia from './learning/virginia.jsx'
import Vermont from './learning/vermont.jsx'
import Utah from './learning/utah.jsx'
import Texas from './learning/texas.jsx'
import Tennessee from './learning/tennessee.jsx'
import Southdakota from './learning/southdakota.jsx'
import Southcarolina from './learning/southcarolina.jsx'
import Rhodeisland from './learning/rhodeisland.jsx'
import Pennsylvania from './learning/pennsylvania.jsx'
import Oregon from './learning/oregon.jsx'
import Oklahoma from './learning/oklahoma.jsx'
import Ohio from './learning/ohio.jsx'
import Northdakota from './learning/northdakota.jsx'
import Northcarolina from './learning/northcarolina.jsx'
import Newyork from './learning/newyork.jsx'
import Newmexico from './learning/newmexico.jsx'
import Newjersey from './learning/newjersey.jsx'
import Newhampshire from './learning/newhampshire.jsx'
import Nevada from './learning/nevada.jsx'
import Nebraska from './learning/nebraska.jsx'
import Montana from './learning/montana.jsx'
import Missouri from './learning/missouri.jsx'
import Mississippi from './learning/mississippi.jsx'
import Minnesota from './learning/minnesota.jsx'
import Michigan from './learning/michigan.jsx'
import Massachusetts from './learning/massachusetts.jsx'
import Maryland from './learning/maryland.jsx'
import Maine from './learning/maine.jsx'
import Louisiana from './learning/louisiana.jsx'
import Kentucky from './learning/kentucky.jsx'
import Kansas from './learning/kansas.jsx'
import JoinCard from './components/joinCard.jsx'
import Login from './components/login.jsx'
import TutorFinder from './teacher/find.jsx'


import Us from './teacher/us1.jsx'
import Us1 from './teacher/us1.jsx'
import Uganda1 from './teacher/uganda1.jsx'
import Canada1 from './teacher/canada1.jsx'
import Nigeria1 from './teacher/nigeria1.jsx'
import Southafrica1 from './teacher/southafrica1.jsx'
import Australia1 from './teacher/australia1.jsx'
import Zambia1 from './teacher/zambia1.jsx'
import Tutoring from './teacher/tutoring.jsx'
import Uganda1_kindergarten from './teacher/uganda1_kindergarten.jsx'
import Uganda1_primary from './teacher/uganda1_primary.jsx'
import Uganda1_ordinary_secondary from './teacher/uganda1_ordinary_secondary.jsx'
import Uganda1_advanced_secondary from './teacher/uganda1_advanced_secondary.jsx'
import Uganda1_mature_entry from './teacher/uganda1_mature_entry.jsx'
import Uganda1_university from './teacher/uganda1_university.jsx'
import Uganda1_kindergarten_lang from './teacher/uganda1_kindergarten_lang.jsx'
import Uganda1_kindergarten_math from './teacher/uganda1_kindergarten_math.jsx'
import Uganda1_kindergarten_envir from './teacher/uganda1_kindergarten_envir.jsx'
import Uganda1_kindergarten_pers from './teacher/uganda1_kindergarten_pers.jsx'
import Uganda1_kindergarten_phy from './teacher/uganda1_kindergarten_phy.jsx'
import Uganda1_kindergarten_crea from './teacher/uganda1_kindergarten_crea.jsx'
import Uganda1_primary_eng from './teacher/uganda1_primary_eng.jsx'
import Uganda1_primary_math from './teacher/uganda1_primary_math.jsx'
import Uganda1_primary_scie from './teacher/uganda1_primary_scie.jsx'
import Uganda1_primary_soc from './teacher/uganda1_primary_soc.jsx'
import Uganda1_ordinary_secondary_agr from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_agr.jsx'
import Uganda1_ordinary_secondary_ara from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_ara.jsx'
import Uganda1_ordinary_secondary_bio from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_bio.jsx'
import Uganda1_ordinary_secondary_che from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_che.jsx'
import Uganda1_ordinary_secondary_chi from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_chi.jsx'
import Uganda1_ordinary_secondary_eng from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_eng.jsx'
import Uganda1_ordinary_secondary_ent from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_ent.jsx'
import Uganda1_ordinary_secondary_fin from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_fin.jsx'
import Uganda1_ordinary_secondary_fre from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_fre.jsx'
import Uganda1_ordinary_secondary_geo from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_geo.jsx'
import Uganda1_ordinary_secondary_ger from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_ger.jsx'
import Uganda1_ordinary_secondary_his from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_his.jsx'
import Uganda1_ordinary_secondary_inf from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_inf.jsx'
import Uganda1_ordinary_secondary_ire from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_ire.jsx'
import Uganda1_ordinary_secondary_kis from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_kis.jsx'
import Uganda1_ordinary_secondary_lat from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_lat.jsx'
import Uganda1_ordinary_secondary_lit from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_lit.jsx'
import Uganda1_ordinary_secondary_lug from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_lug.jsx'
import Uganda1_ordinary_secondary_lus from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_lus.jsx'
import Uganda1_ordinary_secondary_math from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_math.jsx'
import Uganda1_ordinary_secondary_nut from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_nut.jsx'
import Uganda1_ordinary_secondary_ped from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_ped.jsx'
import Uganda1_ordinary_secondary_per from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_per.jsx'
import Uganda1_ordinary_secondary_phy from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_phy.jsx'
import Uganda1_ordinary_secondary_tec from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_tec.jsx'
import Uganda1_ordinary_secondary_gen from './teacher/uganda1_ordinary_secondary/uganda1_ordinary_secondary_gen.jsx'
import Uganda1_advanced_secondary_agr from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_agr.jsx'
import Uganda1_advanced_secondary_ara from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_ara.jsx'
import Uganda1_advanced_secondary_bio from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_bio.jsx'
import Uganda1_advanced_secondary_che from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_che.jsx'
import Uganda1_advanced_secondary_chi from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_chi.jsx'
import Uganda1_advanced_secondary_eng from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_eng.jsx'
import Uganda1_advanced_secondary_ent from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_ent.jsx'
import Uganda1_advanced_secondary_fin from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_fin.jsx'
import Uganda1_advanced_secondary_fre from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_fre.jsx'
import Uganda1_advanced_secondary_gen from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_gen.jsx'
import Uganda1_advanced_secondary_geo from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_geo.jsx'
import Uganda1_advanced_secondary_ger from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_ger.jsx'
import Uganda1_advanced_secondary_his from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_his.jsx'
import Uganda1_advanced_secondary_inf from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_inf.jsx'
import Uganda1_advanced_secondary_ire from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_ire.jsx'
import Uganda1_advanced_secondary_kis from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_kis.jsx'
import Uganda1_advanced_secondary_lat from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_lat.jsx'
import Uganda1_advanced_secondary_lit from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_lit.jsx'
import Uganda1_advanced_secondary_lug from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_lug.jsx'
import Uganda1_advanced_secondary_lus from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_lus.jsx'
import Uganda1_advanced_secondary_math from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_math.jsx'
import Uganda1_advanced_secondary_nut from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_nut.jsx'
import Uganda1_advanced_secondary_ped from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_ped.jsx'
import Uganda1_advanced_secondary_per from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_per.jsx'
import Uganda1_advanced_secondary_phy from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_phy.jsx'
import Uganda1_advanced_secondary_tec from './teacher/uganda1_advanced_secondary/uganda1_advanced_secondary_tec.jsx'
import Uganda1_mature_entry_eng from './teacher/uganda1_mature_entry_eng.jsx'
import Uganda1_mature_entry_math from './teacher/uganda1_mature_entry_math.jsx'
import Uganda1_mature_entry_gen from './teacher/uganda1_mature_entry_gen.jsx'
import Uganda1_mature_entry_apt from './teacher/uganda1_mature_entry_apt.jsx'
import Uganda1_university_agr from './teacher/uganda1_university_agr.jsx'
import Uganda1_university_alg from './teacher/uganda1_university_alg.jsx'
import Uganda1_university_bus from './teacher/uganda1_university_bus.jsx'
import Uganda1_university_cal from './teacher/uganda1_university_cal.jsx'
import Uganda1_university_com from './teacher/uganda1_university_com.jsx'
import Uganda1_university_comp from './teacher/uganda1_university_comp.jsx'
import Uganda1_university_eco from './teacher/uganda1_university_eco.jsx'
import Uganda1_university_edu from './teacher/uganda1_university_edu.jsx'
import Uganda1_university_eng from './teacher/uganda1_university_eng.jsx'
import Uganda1_university_geo from './teacher/uganda1_university_geo.jsx'
import Uganda1_university_med from './teacher/uganda1_university_med.jsx'
import Uganda1_university_nur from './teacher/uganda1_university_nur.jsx'
import Uganda1_university_pha from './teacher/uganda1_university_pha.jsx'
import Uganda1_university_psy from './teacher/uganda1_university_psy.jsx'
import Uganda1_university_pub from './teacher/uganda1_university_pub.jsx'
import Uganda1_university_sta from './teacher/uganda1_university_sta.jsx'
import Us1_pre_cre from './teacher/us1_pre_cre.jsx'
import Us1_pre_lit from './teacher/us1_pre_lit.jsx'
import Us1_pre_mat from './teacher/us1_pre_mat.jsx'
import Us1_pre_mus from './teacher/us1_pre_mus.jsx'
import Us1_pre_phy from './teacher/us1_pre_phy.jsx'
import Us1_pre_pra from './teacher/us1_pre_pra.jsx'
import Us1_pre_sci from './teacher/us1_pre_sci.jsx'
import Us1_pre_sed from './teacher/us1_pre_sed.jsx'
import Us1_pre_soc from './teacher/us1_pre_soc.jsx'
import Us1_pre from './teacher/us1_pre.jsx'
import Us1_ele from './teacher/us1_ele.jsx'
import Us1_ele_art from './teacher/us1_ele_art.jsx'
import Us1_ele_ela from './teacher/us1_ele_ela.jsx'
import Us1_ele_lib from './teacher/us1_ele_lib.jsx'
import Us1_ele_mat from './teacher/us1_ele_mat.jsx'
import Us1_ele_mus from './teacher/us1_ele_mus.jsx'
import Us1_ele_phy from './teacher/us1_ele_phy.jsx'
import Us1_ele_rel from './teacher/us1_ele_rel.jsx'
import Us1_ele_sci from './teacher/us1_ele_sci.jsx'
import Us1_ele_soc from './teacher/us1_ele_soc.jsx'
import Us1_ele_for from './teacher/us1_ele_for.jsx'
import Us1_ele_tec from './teacher/us1_ele_tec.jsx'
import Us1_mid from './teacher/us1_mid/us1_mid.jsx'
import Us1_mid_art from './teacher/us1_mid/us1_mid_art.jsx'
import Us1_mid_ela from './teacher/us1_mid/us1_mid_ela.jsx'
import Us1_mid_for from './teacher/us1_mid/us1_mid_for.jsx'
import Us1_mid_hea from './teacher/us1_mid/us1_mid_hea.jsx'
import Us1_mid_mat from './teacher/us1_mid/us1_mid_mat.jsx'
import Us1_mid_phy from './teacher/us1_mid/us1_mid_phy.jsx'
import Us1_mid_sci from './teacher/us1_mid/us1_mid_sci.jsx'
import Us1_mid_soc from './teacher/us1_mid/us1_mid_soc.jsx'
import Us1_mid_tec from './teacher/us1_mid/us1_mid_ste.jsx'
import Us1_mid_ste from './teacher/us1_mid/us1_mid_ste.jsx'
import Us1_mid_voc from './teacher/us1_mid/us1_mid_voc.jsx'
import Us1_st from './teacher/us1_st.jsx'
import Us1_st_acc from './teacher/us1_st_acc.jsx'
import Us1_st_act from './teacher/us1_st_act.jsx'
import Us1_st_ale from './teacher/us1_st_ale.jsx'
import Us1_st_ap from './teacher/us1_st_ap.jsx'
import Us1_st_bar from './teacher/us1_st_bar.jsx'
import Us1_st_clt from './teacher/us1_st_clt.jsx'
import Us1_st_cog from './teacher/us1_st_cog.jsx'
import Us1_st_dat from './teacher/us1_st_dat.jsx'
import Us1_st_ged from './teacher/us1_st_ged.jsx'
import Us1_st_gma from './teacher/us1_st_gma.jsx'
import Us1_st_gre from './teacher/us1_st_gre.jsx'
import Us1_st_ib from './teacher/us1_st_ib.jsx'
import Us1_st_iel from './teacher/us1_st_iel.jsx'
import Us1_st_iow from './teacher/us1_st_iow.jsx'
import Us1_st_lsa from './teacher/us1_st_lsa.jsx'
import Us1_st_mca from './teacher/us1_st_mca.jsx'
import Us1_st_ncl from './teacher/us1_st_ncl.jsx'
import Us1_st_oat from './teacher/us1_st_oat.jsx'
import Us1_st_pca from './teacher/us1_st_pca.jsx'
import Us1_st_psa from './teacher/us1_st_psa.jsx'
import Us1_st_sat from './teacher/us1_st_sat.jsx'
import Us1_st_sta from './teacher/us1_st_sta.jsx'
import Us1_st_ter from './teacher/us1_st_ter.jsx'
import Us1_st_toe from './teacher/us1_st_toe.jsx'
import Us1_st_usm from './teacher/us1_st_usm.jsx'

import Tutor1 from './teacher/tutor1.jsx'

import Tutors_23 from './teacher/tutors_23.jsx'
import SuccessPage from './teacher/success.jsx'
import AuthProvider from './teacher/AuthContext.jsx'; 
import Profile from './teacher/profile.jsx'
import AdminDashboard from './teacher/admin-dashboard.jsx'
import Register from './components/register.jsx'
import RoleSelection from './components/roleselection.jsx'
import PendingApproval from './components/pendingapproval.jsx'
import CompleteProfile from './teacher/complete_profile.jsx'

import ProtectedRoute from './components/ProtectedRoute.jsx'
import Admin from './footer/admin.jsx';
import AdminSettings from './teacher/AdminSettings.jsx';
import Tutoring_attributes from './teacher/tutoring_attributes.jsx';
import Assessment_attributes from './teacher/assessment_attributes.jsx';
import Assess_cli from './teacher/assess_cli.jsx';
import Assess_con from './teacher/assess_con.jsx';
import Assess_dev from './teacher/assess_dev.jsx';
import Assess_rep from './teacher/assess_rep.jsx';
import Assess_too from './teacher/assess_too.jsx';


const AppRoutes = () => {

 const { currentUser } = useAuth();   
  return (

    <div>  

     <Router>
    <Tutoring_attributes />
    <Assessment_attributes />
      <Routes>
        <Route element={<Layout/>}>      
        <Route path="/" element={<Logo/>}/>
        <Route path="/home" element={<Home/>}/>
        <Route path="/threedots" element={<Threedots/>}/>
        <Route path="/podcast" element={<Podcast/>}/>
        <Route path="/blog" element={<Blog/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="/register" element={<Register/>}/>
        <Route path="/references" element={<References/>}/>
        <Route path="/learning" element={<Learning/>}/>
        <Route path="/assessment" element={<Assessment/>}/>
        <Route path="/assessment/assess_con" element={<Assess_con />}/>
        <Route path="/assessment/assess_cli" element={<Assess_cli />}/>
        <Route path="/assessment/assess_dev" element={<Assess_dev />}/>
        <Route path="/assessment/assess_too" element={<Assess_too />}/>
        <Route path="/assessment/assess_rep" element={<Assess_rep />}/>
        <Route path="/feedback" element={<Feedback/>}/>
        <Route path="/international" element={<International />}/>
        <Route path="/tutoring" element={<Tutoring/>}/>
        <Route path="/assessors" element={<Assessors/>}/>
        <Route path="/futurize" element={<Futurize/>}/> 
        <Route path="/join" element={<Join/>}/>
         
        <Route path="/joinCard" element={<JoinCard />}/>
      <Route path="/success" element={<SuccessPage />}/>
        <Route path="/tutoring/how" element={<How />}/>
        <Route path="/tutoring/find" element={<TutorFinder />}/>        
        <Route path="/tutoring/tutor1" element={<Tutor1 />}/>
        <Route path="/tutoring/tutors_23" element={<Tutors_23 />}/>       
       <Route path="/tutoring/profile" element={<Profile />}/>
         {/*<Route path="/ProtectedRoute" element={<ProtectedRoute />}/>*/}        
         <Route element={<AdminRouteGuard currentUser={currentUser} />}>
    {/* Anything inside here requires role === 'admin' to render */}
    <Route path="/support" element={<Support />} />
    <Route path="/tutoring/admin-dashboard" element={<AdminDashboard />} />
    <Route path="/admin" element={<Admin />} />
  </Route>
  <Route path="/login" element={<Login />} />        
  <Route path="/pendingapproval" element={<PendingApproval />}/>
   <Route path="/tutoring/complete_profile" element={<CompleteProfile />}/> 
        <Route path="/AdminSettings" element={<AdminSettings />} />
        <Route path="/roleselection" element={<RoleSelection />}/>
        <Route path="/tutoring/learner/us1" element={<Us1/>}/>
        <Route path="/tutoring/learner/us1/us1_pre" element={<Us1_pre/>}/>
        <Route path="/tutoring/learner/us1/us1_pre/us1_pre_cre" element={<Us1_pre_cre/>}/>
        <Route path="/tutoring/learner/us1/us1_pre/us1_pre_lit" element={<Us1_pre_lit/>}/>
        <Route path="/tutoring/learner/us1/us1_pre/us1_pre_mat" element={<Us1_pre_mat/>}/>
        <Route path="/tutoring/learner/us1/us1_pre/us1_pre_mus" element={<Us1_pre_mus/>}/>
        <Route path="/tutoring/learner/us1/us1_pre/us1_pre_phy" element={<Us1_pre_phy/>}/>
        <Route path="/tutoring/learner/us1/us1_pre/us1_pre_pra" element={<Us1_pre_pra/>}/>
        <Route path="/tutoring/learner/us1/us1_pre/us1_pre_sci" element={<Us1_pre_sci/>}/>
        <Route path="/tutoring/learner/us1/us1_pre/us1_pre_sed" element={<Us1_pre_sed/>}/>
        <Route path="/tutoring/learner/us1/us1_pre/us1_pre_soc" element={<Us1_pre_soc/>}/>        
        <Route path="/tutoring/learner/us1/us1_ele" element={<Us1_ele/>}/>
        <Route path="/tutoring/learner/us1/us1_ele/us1_ele_art" element={<Us1_ele_art/>}/>
        <Route path="/tutoring/learner/us1/us1_ele/us1_ele_ela" element={<Us1_ele_ela/>}/>
        <Route path="/tutoring/learner/us1/us1_ele/us1_ele_lib" element={<Us1_ele_lib/>}/>
        <Route path="/tutoring/learner/us1/us1_ele/us1_ele_mat" element={<Us1_ele_mat/>}/>
        <Route path="/tutoring/learner/us1/us1_ele/us1_ele_mus" element={<Us1_ele_mus/>}/>
        <Route path="/tutoring/learner/us1/us1_ele/us1_ele_phy" element={<Us1_ele_phy/>}/>
        <Route path="/tutoring/learner/us1/us1_ele/us1_ele_rel" element={<Us1_ele_rel/>}/>
        <Route path="/tutoring/learner/us1/us1_ele/us1_ele_sci" element={<Us1_ele_sci/>}/>
        <Route path="/tutoring/learner/us1/us1_ele/us1_ele_soc" element={<Us1_ele_soc/>}/>
        <Route path="/tutoring/learner/us1/us1_ele/us1_ele_for" element={<Us1_ele_for/>}/>
        <Route path="/tutoring/learner/us1/us1_ele/us1_ele_tec" element={<Us1_ele_tec/>}/>   
        <Route path="/tutoring/learner/us1/us1_mid" element={<Us1_mid/>}/>
        <Route path="/tutoring/learner/us1/us1_mid/us1_mid_art" element={<Us1_mid_art/>}/>
        <Route path="/tutoring/learner/us1/us1_mid/us1_mid_ela" element={<Us1_mid_ela/>}/>
        <Route path="/tutoring/learner/us1/us1_mid/us1_mid_for" element={<Us1_mid_for/>}/>
        <Route path="/tutoring/learner/us1/us1_mid/us1_mid_hea" element={<Us1_mid_hea/>}/>
        <Route path="/tutoring/learner/us1/us1_mid/us1_mid_mat" element={<Us1_mid_mat/>}/>
        <Route path="/tutoring/learner/us1/us1_mid/us1_mid_phy" element={<Us1_mid_phy/>}/>
        <Route path="/tutoring/learner/us1/us1_mid/us1_mid_sci" element={<Us1_mid_sci/>}/>
        <Route path="/tutoring/learner/us1/us1_mid/us1_mid_soc" element={<Us1_mid_soc/>}/>
        <Route path="/tutoring/learner/us1/us1_mid/us1_mid_ste" element={<Us1_mid_ste/>}/>
        <Route path="/tutoring/learner/us1/us1_mid/us1_mid_voc" element={<Us1_mid_voc/>}/>
        <Route path="/tutoring/learner/us1/us1_hig" element={<Us1/>}/>
        <Route path="/tutoring/learner/us1/us1_st" element={<Us1_st/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_acc" element={<Us1_st_acc/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_act" element={<Us1_st_act/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_ale" element={<Us1_st_ale/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_ap" element={<Us1_st_ap/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_bar" element={<Us1_st_bar/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_clt" element={<Us1_st_clt/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_cog" element={<Us1_st_cog/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_dat" element={<Us1_st_dat/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_ged" element={<Us1_st_ged/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_gma" element={<Us1_st_gma/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_gre" element={<Us1_st_gre/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_ib" element={<Us1_st_ib/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_iel" element={<Us1_st_iel/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_iow" element={<Us1_st_iow/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_lsa" element={<Us1_st_lsa/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_mca" element={<Us1_st_mca/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_ncl" element={<Us1_st_ncl/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_oat" element={<Us1_st_oat/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_pca" element={<Us1_st_pca/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_psa" element={<Us1_st_psa/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_sat" element={<Us1_st_sat/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_sta" element={<Us1_st_sta/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_ter" element={<Us1_st_ter/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_toe" element={<Us1_st_toe/>}/>
        <Route path="/tutoring/learner/us1/us1_st/us1_st_usm" element={<Us1_st_usm/>}/>        
        <Route path="/tutoring/learner/us1/us1_ter" element={<Us1/>}/>
        <Route path="/tutoring/learner/uganda1" element={<Uganda1/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_kindergarten" element={<Uganda1_kindergarten/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_kindergarten/uganda1_kindergarten_lang" element={<Uganda1_kindergarten_lang/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_kindergarten/uganda1_kindergarten_math" element={<Uganda1_kindergarten_math/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_kindergarten/uganda1_kindergarten_envir" element={<Uganda1_kindergarten_envir/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_kindergarten/uganda1_kindergarten_pers" element={<Uganda1_kindergarten_pers/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_kindergarten/uganda1_kindergarten_phy" element={<Uganda1_kindergarten_phy/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_kindergarten/uganda1_kindergarten_crea" element={<Uganda1_kindergarten_crea/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_primary" element={<Uganda1_primary/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_primary/uganda1_primary_eng" element={<Uganda1_primary_eng/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_primary/uganda1_primary_math" element={<Uganda1_primary_math/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_primary/uganda1_primary_scie" element={<Uganda1_primary_scie/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_primary/uganda1_primary_soc" element={<Uganda1_primary_soc/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary" element={<Uganda1_ordinary_secondary/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_agr" element={<Uganda1_ordinary_secondary_agr/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_ara" element={<Uganda1_ordinary_secondary_ara/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_bio" element={<Uganda1_ordinary_secondary_bio/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_che" element={<Uganda1_ordinary_secondary_che/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_chi" element={<Uganda1_ordinary_secondary_chi/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_eng" element={<Uganda1_ordinary_secondary_eng/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_ent" element={<Uganda1_ordinary_secondary_ent/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_fin" element={<Uganda1_ordinary_secondary_fin/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_fre" element={<Uganda1_ordinary_secondary_fre/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_gen" element={<Uganda1_ordinary_secondary_gen/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_geo" element={<Uganda1_ordinary_secondary_geo/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_ger" element={<Uganda1_ordinary_secondary_ger/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_his" element={<Uganda1_ordinary_secondary_his/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_inf" element={<Uganda1_ordinary_secondary_inf/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_ire" element={<Uganda1_ordinary_secondary_ire/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_kis" element={<Uganda1_ordinary_secondary_kis/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_lat" element={<Uganda1_ordinary_secondary_lat/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_lit" element={<Uganda1_ordinary_secondary_lit/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_lug" element={<Uganda1_ordinary_secondary_lug/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_lus" element={<Uganda1_ordinary_secondary_lus/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_math" element={<Uganda1_ordinary_secondary_math/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_nut" element={<Uganda1_ordinary_secondary_nut/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_ped" element={<Uganda1_ordinary_secondary_ped/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_per" element={<Uganda1_ordinary_secondary_per/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_phy" element={<Uganda1_ordinary_secondary_phy/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_ordinary_secondary/uganda1_ordinary_secondary_tec" element={<Uganda1_ordinary_secondary_tec/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary" element={<Uganda1_advanced_secondary/>}/> 

        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" element={<Uganda1_advanced_secondary_agr/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_ara" element={<Uganda1_advanced_secondary_ara/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_bio" element={<Uganda1_advanced_secondary_bio/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_che" element={<Uganda1_advanced_secondary_che/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_chi" element={<Uganda1_advanced_secondary_chi/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_eng" element={<Uganda1_advanced_secondary_eng/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_ent" element={<Uganda1_advanced_secondary_ent/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_fin" element={<Uganda1_advanced_secondary_fin/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_fre" element={<Uganda1_advanced_secondary_fre/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_gen" element={<Uganda1_advanced_secondary_gen/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_geo" element={<Uganda1_advanced_secondary_geo/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_ger" element={<Uganda1_advanced_secondary_ger/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_his" element={<Uganda1_advanced_secondary_his/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_inf" element={<Uganda1_advanced_secondary_inf/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_ire" element={<Uganda1_advanced_secondary_ire/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_kis" element={<Uganda1_advanced_secondary_kis/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_lat" element={<Uganda1_advanced_secondary_lat/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_lit" element={<Uganda1_advanced_secondary_lit/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_lug" element={<Uganda1_advanced_secondary_lug/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_lus" element={<Uganda1_advanced_secondary_lus/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_math" element={<Uganda1_advanced_secondary_math/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_nut" element={<Uganda1_advanced_secondary_nut/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_ped" element={<Uganda1_advanced_secondary_ped/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_per" element={<Uganda1_advanced_secondary_per/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_phy" element={<Uganda1_advanced_secondary_phy/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_tec" element={<Uganda1_advanced_secondary_tec/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_mature_entry" element={<Uganda1_mature_entry/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_mature_entry/uganda1_mature_entry_eng" element={<Uganda1_mature_entry_eng/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_mature_entry/uganda1_mature_entry_math" element={<Uganda1_mature_entry_math/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_mature_entry/uganda1_mature_entry_gen" element={<Uganda1_mature_entry_gen/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_mature_entry/uganda1_mature_entry_apt" element={<Uganda1_mature_entry_apt/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university" element={<Uganda1_university/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" element={<Uganda1_university_agr/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_alg" element={<Uganda1_university_alg/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_bus" element={<Uganda1_university_bus/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_cal" element={<Uganda1_university_cal/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_com" element={<Uganda1_university_com/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_comp" element={<Uganda1_university_comp/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_eco" element={<Uganda1_university_eco/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_edu" element={<Uganda1_university_edu/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_eng" element={<Uganda1_university_eng/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_geo" element={<Uganda1_university_geo/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_med" element={<Uganda1_university_med/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_nur" element={<Uganda1_university_nur/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_pha" element={<Uganda1_university_pha/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_psy" element={<Uganda1_university_psy/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_pub" element={<Uganda1_university_pub/>}/>
        <Route path="/tutoring/learner/uganda1/uganda1_university/uganda1_university_sta" element={<Uganda1_university_sta/>}/>
        <Route path="/tutoring/learner/canada1" element={<Canada1/>}/>
        <Route path="/tutoring/learner/nigeria1" element={<Nigeria1/>}/>
        <Route path="/tutoring/learner/southafrica1" element={<Southafrica1/>}/>
        <Route path="/tutoring/learner/australia1" element={<Australia1/>}/>
         <Route path="/tutoring/learner/zambia1" element={<Zambia1/>}/>
        <Route path="/careers" element={<Careers/>}/>
        <Route path="/company" element={<Company/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/faq" element={<Faq/>}/>
        <Route path="/interpret" element={<Interpret/>}/>
        <Route path="/privacy" element={<Privacy/>}/>

        <Route path="/terms" element={<Terms/>}/>
        <Route path="/testimony" element={<Testimony/>}/>
        <Route path="/advice" element={<Advice/>}/>

        <Route path= "/learning/alabama" element={<Alabama/>}/>
        <Route path= "/learning/alaska" element={<Alaska/>}/>
        <Route path= "/learning/arizona" element={<Arizona/>}/>
        <Route path= "/learning/arkansas" element={<Arkansas/>}/> 
        <Route path= "/learning/california" element={<California/>}/>
        <Route path="/learning/prekindergartengrade_k0" element={<Prekindergartengrade_k0/>}/>
        <Route path="/learning/prekindergartengrade_k0/prekindergartengrade_k0math" element={<Prekindergartengrade_k0math/>}/> 
        <Route path="/learning/prekindergartengrade_k0/prekindergartengrade_k0eng" element={<Prekindergartengrade_k0eng/>}/> 
        <Route path="/learning/prekindergartengrade_k0/prekindergartengrade_k0scie" element={<Prekindergartengrade_k0scie/>}/> 
        <Route path="/learning/prekindergartengrade_k0/prekindergartengrade_k0soc" element={<Prekindergartengrade_k0soc/>}/> 
      
        <Route path="/learning/kindergartengrade_k" element={<Kindergartengrade_k/>}/>
        <Route path="/learning/kindergartengrade_k/kindergartengrade_kmath" element={<Kindergartengrade_kmath/>}/> 
        <Route path="/learning/kindergartengrade_k/kindergartengrade_keng" element={<Kindergartengrade_keng/>}/> 
        <Route path="/learning/kindergartengrade_k/kindergartengrade_kscie" element={<Kindergartengrade_kscie/>}/> 
        <Route path="/learning/kindergartengrade_k/kindergartengrade_ksoc" element={<Kindergartengrade_ksoc/>}/> 
        <Route path="/learning/firstgrade_k1" element={<Firstgrade_k1/>}/>
        <Route path="/learning/firstgrade_k1/firstgrade_k1math" element={<Firstgrade_k1math/>}/> 
        <Route path="/learning/firstgrade_k1/firstgrade_k1eng" element={<Firstgrade_k1eng/>}/> 
        <Route path="/learning/firstgrade_k1/firstgrade_k1scie" element={<Firstgrade_k1scie/>}/> 
        <Route path="/learning/firstgrade_k1/firstgrade_k1soc" element={<Firstgrade_k1soc/>}/> 
        <Route path="/learning/secondgrade_k2" element={<Secondgrade_k2/>}/>
        <Route path="/learning/secondgrade_k2/secondgrade_k2math" element={<Secondgrade_k2math/>}/> 
        <Route path="/learning/secondgrade_k2/secondgrade_k2eng" element={<Secondgrade_k2eng/>}/> 
        <Route path="/learning/secondgrade_k2/secondgrade_k2scie" element={<Secondgrade_k2scie/>}/> 
        <Route path="/learning/secondgrade_k2/secondgrade_k2soc" element={<Secondgrade_k2soc/>}/> 
        <Route path="/learning/thirdgrade_k3" element={<Thirdgrade_k3/>}/>
        <Route path="/learning/thirdgrade_k3/thirdgrade_k3math" element={<Thirdgrade_k3math/>}/> 
        <Route path="/learning/thirdgrade_k3/thirdgrade_k3eng" element={<Thirdgrade_k3eng/>}/> 
        <Route path="/learning/thirdgrade_k3/thirdgrade_k3scie" element={<Thirdgrade_k3scie/>}/> 
        <Route path="/learning/thirdgrade_k3/thirdgrade_k3soc" element={<Thirdgrade_k3soc/>}/> 
        <Route path="/learning/fourthgrade_k4" element={<Fourthgrade_k4/>}/>
        <Route path="/learning/fourthgrade_k4/fourthgrade_k4math" element={<Fourthgrade_k4math/>}/> 
        <Route path="/learning/fourthgrade_k4/fourthgrade_k4eng" element={<Fourthgrade_k4eng/>}/> 
        <Route path="/learning/fourthgrade_k4/fourthgrade_k4scie" element={<Fourthgrade_k4scie/>}/> 
        <Route path="/learning/fourthgrade_k4/fourthgrade_k4soc" element={<Fourthgrade_k4soc/>}/> 
        <Route path="/learning/fifthgrade_k5" element={<Fifthgrade_k5/>}/>
        <Route path="/learning/fifthgrade_k5/fifthgrade_k5math" element={<Fifthgrade_k5math/>}/> 
        <Route path="/learning/fifthgrade_k5/fifthgrade_k5eng" element={<Fifthgrade_k5eng/>}/> 
        <Route path="/learning/fifthgrade_k5/fifthgrade_k5scie" element={<Fifthgrade_k5scie/>}/> 
        <Route path="/learning/fifthgrade_k5/fifthgrade_k5soc" element={<Fifthgrade_k5soc/>}/> 
        <Route path="/learning/sixthgrade_k6" element={<Sixthgrade_k6/>}/>
        <Route path="/learning/sixthgrade_k6/sixthgrade_k6math" element={<Sixthgrade_k6math/>}/> 
        <Route path="/learning/sixthgrade_k6/sixthgrade_k6eng" element={<Sixthgrade_k6eng/>}/> 
        <Route path="/learning/sixthgrade_k6/sixthgrade_k6scie" element={<Sixthgrade_k6scie/>}/> 
        <Route path="/learning/sixthgrade_k6/sixthgrade_k6soc" element={<Sixthgrade_k6soc/>}/> 
        <Route path="/learning/seventhgrade_k7" element={<Seventhgrade_k7/>}/>
        <Route path="/learning/seventhgrade_k7/seventhgrade_k7math" element={<Seventhgrade_k7math/>}/> 
        <Route path="/learning/seventhgrade_k7/seventhgrade_k7eng" element={<Seventhgrade_k7eng/>}/> 
        <Route path="/learning/seventhgrade_k7/seventhgrade_k7scie" element={<Seventhgrade_k7scie/>}/> 
        <Route path="/learning/seventhgrade_k7/seventhgrade_k7soc" element={<Seventhgrade_k7soc/>}/> 
        <Route path="/learning/eighthgrade_k8" element={<Eighthgrade_k8/>}/> 
        <Route path="/learning/eighthgrade_k8/eighthgrade_k8math" element={<Eighthgrade_k8math/>}/> 
        <Route path="/learning/eighthgrade_k8/eighthgrade_k8eng" element={<Eighthgrade_k8eng/>}/> 
        <Route path="/learning/eighthgrade_k8/eighthgrade_k8scie" element={<Eighthgrade_k8scie/>}/> 
        <Route path="/learning/eighthgrade_k8/eighthgrade_k8soc" element={<Eighthgrade_k8soc/>}/> 
        <Route path="/learning/ninethgrade_k9" element={<Ninethgrade_k9/>}/>
        <Route path="/learning/ninethgrade_k9/ninethgrade_k9math" element={<Ninethgrade_k9math/>}/> 
        <Route path="/learning/ninethgrade_k9/ninethgrade_k9eng" element={<Ninethgrade_k9eng/>}/> 
        <Route path="/learning/ninethgrade_k9/ninethgrade_k9scie" element={<Ninethgrade_k9scie/>}/> 
        <Route path="/learning/ninethgrade_k9/ninethgrade_k9soc" element={<Ninethgrade_k9soc/>}/> 
        <Route path="/learning/tenthgrade_k10" element={<Tenthgrade_k10/>}/>
        <Route path="/learning/tenthgrade_k10/tenthgrade_k10math" element={<Tenthgrade_k10math/>}/> 
        <Route path="/learning/tenthgrade_k10/tenthgrade_k10eng" element={<Tenthgrade_k10eng/>}/> 
        <Route path="/learning/tenthgrade_k10/tenthgrade_k10scie" element={<Tenthgrade_k10scie/>}/> 
        <Route path="/learning/tenthgrade_k10/tenthgrade_k10soc" element={<Tenthgrade_k10soc/>}/> 
        <Route path="/learning/eleventhgrade_k11" element={<Eleventhgrade_k11/>}/>
        <Route path="/learning/eleventhgrade_k11/eleventhgrade_k11math" element={<Eleventhgrade_k11math/>}/> 
        <Route path="/learning/eleventhgrade_k11/eleventhgrade_k11eng" element={<Eleventhgrade_k11eng/>}/> 
        <Route path="/learning/eleventhgrade_k11/eleventhgrade_k11scie" element={<Eleventhgrade_k11scie/>}/> 
        <Route path="/learning/eleventhgrade_k11/eleventhgrade_k11soc" element={<Eleventhgrade_k11soc/>}/> 
        <Route path="/learning/twelvethgrade_k12" element={<Twelvethgrade_k12/>}/>
        <Route path="/learning/twelvethgrade_k12/twelvethgrade_k12math" element={<Twelvethgrade_k12math/>}/> 
        <Route path="/learning/twelvethgrade_k12/twelvethgrade_k12eng" element={<Twelvethgrade_k12eng/>}/> 
        <Route path="/learning/twelvethgrade_k12/twelvethgrade_k12scie" element={<Twelvethgrade_k12scie/>}/> 
        <Route path="/learning/twelvethgrade_k12/twelvethgrade_k12soc" element={<Twelvethgrade_k12soc/>}/> 
        <Route path="/learning/independentlearning_k13" element={<Independentlearning_k13/>}/>
        <Route path="/learning/independentlearning_k13/independentlearning_k13math" element={<Independentlearning_k13math/>}/> 
        <Route path="/learning/independentlearning_k13/independentlearning_k13eng" element={<Independentlearning_k13eng/>}/> 
        <Route path="/learning/independentlearning_k13/independentlearning_k13scie" element={<Independentlearning_k13scie/>}/> 
        <Route path="/learning/independentlearning_k13/independentlearning_k13soc" element={<Independentlearning_k13soc/>}/> 
        <Route path= "/learning/colorado" element={<Colorado/>}/>
        <Route path= "/learning/connecticut" element={<Connecticut/>}/>
        <Route path= "/learning/delaware" element={<Delaware/>}/>
        <Route path= "/learning/florida" element={<Florida/>}/>
        <Route path= "/learning/georgia" element={<Georgia/>}/>
        <Route path= "/learning/hawaii" element={<Hawaii/>}/>
        <Route path= "/learning/idaho" element={<Idaho/>}/>
        <Route path= "/learning/illinois" element={<Illinois/>}/>
        <Route path= "/learning/indiana" element={<Indiana/>}/>
        <Route path= "/learning/iowa" element={<Iowa/>}/>
        <Route path= "/learning/kansas" element={<Kansas/>}/>
        <Route path= "/learning/kentucky" element={<Kentucky/>}/>
        <Route path= "/learning/louisiana" element={<Louisiana/>}/>
        <Route path= "/learning/maine" element={<Maine/>}/>
        <Route path= "/learning/maryland" element={<Maryland/>}/>
        <Route path= "/learning/massachusetts" element={<Massachusetts/>}/>
        <Route path= "/learning/michigan" element={<Michigan/>}/>
        <Route path= "/learning/minnesota" element={<Minnesota/>}/>
        <Route path= "/learning/mississippi" element={<Mississippi/>}/>
        <Route path= "/learning/missouri" element={<Missouri/>}/>
        <Route path= "/learning/montana" element={<Montana/>}/>
        <Route path= "/learning/nebraska" element={<Nebraska/>}/>
        <Route path= "/learning/nevada" element={<Nevada/>}/>
        <Route path= "/learning/newhampshire" element={<Newhampshire/>}/>
        <Route path= "/learning/newjersey" element={<Newjersey/>}/>
        <Route path= "/learning/newmexico" element={<Newmexico/>}/>
        <Route path= "/learning/newyork" element={<Newyork/>}/>
        <Route path= "/learning/northcarolina" element={<Northcarolina/>}/>
        <Route path= "/learning/northdakota" element={<Northdakota/>}/>
        <Route path= "/learning/ohio" element={<Ohio/>}/>
        <Route path= "/learning/oklahoma" element={<Oklahoma/>}/>
        <Route path= "/learning/oregon" element={<Oregon/>}/>
        <Route path= "/learning/pennsylvania" element={<Pennsylvania/>}/>
        <Route path= "/learning/rhodeisland" element={<Rhodeisland/>}/>
        <Route path= "/learning/southcarolina" element={<Southcarolina/>}/>
        <Route path= "/learning/southdakota" element={<Southdakota/>}/>
        <Route path= "/learning/tennessee" element={<Tennessee/>}/>
        <Route path= "/learning/texas" element={<Texas/>}/>
        <Route path= "/learning/utah" element={<Utah/>}/>
        <Route path= "/learning/vermont" element={<Vermont/>}/>
        <Route path= "/learning/virginia" element={<Virginia/>}/>
        <Route path= "/learning/washington" element={<Washington/>}/>
        <Route path= "/learning/westvirginia" element={<Westvirginia/>}/>
        <Route path= "/learning/wisconsin" element={<Wisconsin/>}/>
        <Route path= "/learning/wyoming" element={<Wyoming/>}/>

      <Route path= "/international/zambia" element={<Zambia />}/>
      <Route path= "/international/southafrica" element={<Southafrica />}/>
      <Route path= "/international/nigeria" element={<Nigeria />}/>
      <Route path= "/international/canada" element={<Canada />}/>
      <Route path= "/international/australia" element={<Australia />}/>
      <Route path= "/international/kenya" element={<Kenya/>}/>
      <Route path= "/international/uganda" element={<Uganda/>}/>
      <Route path= "/international/us" element={<Us/>}/>

      <Route path= "/international/uganda/uganda_baby1" element={<Uganda_baby1/>}/>       
      <Route path="/international/uganda/uganda_baby1/uganda_baby1math" element={<Uganda_baby1math/>}/>
      <Route path="/international/uganda/uganda_baby1/uganda_baby1eng" element={<Uganda_baby1eng/>}/>
      <Route path="/international/uganda/uganda_baby1/uganda_baby1scie" element={<Uganda_baby1scie/>}/>
      <Route path="/international/uganda/uganda_baby1/uganda_baby1soc" element={<Uganda_baby1soc/>}/>      

      <Route path="/international/uganda/uganda_baby2" element={<Uganda_baby2/>}/>
      <Route path="/international/uganda/uganda_baby2/uganda_baby2math" element={<Uganda_baby2math/>}/>
      <Route path="/international/uganda/uganda_baby2/uganda_baby2eng" element={<Uganda_baby2eng/>}/>
      <Route path="/international/uganda/uganda_baby2/uganda_baby2scie" element={<Uganda_baby2scie/>}/>
      <Route path="/international/uganda/uganda_baby2/uganda_baby2soc" element={<Uganda_baby2soc/>}/>      

      <Route path="/international/uganda/uganda_baby3" element={<Uganda_baby3/>}/>
      <Route path="/international/uganda/uganda_baby3/uganda_baby3math" element={<Uganda_baby3math/>}/>
      <Route path="/international/uganda/uganda_baby3/uganda_baby3eng" element={<Uganda_baby3eng/>}/>
      <Route path="/international/uganda/uganda_baby3/uganda_baby3scie" element={<Uganda_baby3scie/>}/>
      <Route path="/international/uganda/uganda_baby3/uganda_baby3soc" element={<Uganda_baby3soc/>}/>

      <Route path="/international/uganda/uganda_p1" element={<Uganda_p1/>}/>
      <Route path="/international/uganda/uganda_p1/uganda_p1math" element={<Uganda_p1math/>}/>
      <Route path="/international/uganda/uganda_p1/uganda_p1eng" element={<Uganda_p1eng/>}/>
      <Route path="/international/uganda/uganda_p1/uganda_p1scie" element={<Uganda_p1scie/>}/>
      <Route path="/international/uganda/uganda_p1/uganda_p1soc" element={<Uganda_p1soc/>}/>

      <Route path="/international/uganda/uganda_p2" element={<Uganda_p2/>}/>
      <Route path="/international/uganda/uganda_p2/uganda_p2math" element={<Uganda_p2math/>}/>
      <Route path="/international/uganda/uganda_p2/uganda_p2eng" element={<Uganda_p2eng/>}/>
      <Route path="/international/uganda/uganda_p2/uganda_p2scie" element={<Uganda_p2scie/>}/>
      <Route path="/international/uganda/uganda_p2/uganda_p2soc" element={<Uganda_p2soc/>}/>

      <Route path="/international/uganda/uganda_p3" element={<Uganda_p3/>}/>
      <Route path="/international/uganda/uganda_p3/uganda_p3math" element={<Uganda_p3math/>}/>
      <Route path="/international/uganda/uganda_p3/uganda_p3eng" element={<Uganda_p3eng/>}/>
      <Route path="/international/uganda/uganda_p3/uganda_p3scie" element={<Uganda_p3scie/>}/>
      <Route path="/international/uganda/uganda_p3/uganda_p3soc" element={<Uganda_p3soc/>}/>

      <Route path="/international/uganda/uganda_p4" element={<Uganda_p4/>}/>
      <Route path="/international/uganda/uganda_p4/uganda_p4math" element={<Uganda_p4math/>}/>
      <Route path="/international/uganda/uganda_p4/uganda_p4eng" element={<Uganda_p4eng/>}/>
      <Route path="/international/uganda/uganda_p4/uganda_p4scie" element={<Uganda_p4scie/>}/>
      <Route path="/international/uganda/uganda_p4/uganda_p4soc" element={<Uganda_p4soc/>}/>

      <Route path="/international/uganda/uganda_p5" element={<Uganda_p5/>}/>
      <Route path="/international/uganda/uganda_p5/uganda_p5math" element={<Uganda_p5math/>}/>
      <Route path="/international/uganda/uganda_p5/uganda_p5eng" element={<Uganda_p5eng/>}/>
      <Route path="/international/uganda/uganda_p5/uganda_p5scie" element={<Uganda_p5scie/>}/>
      <Route path="/international/uganda/uganda_p5/uganda_p5soc" element={<Uganda_p5soc/>}/>

      <Route path="/international/uganda/uganda_p6" element={<Uganda_p6/>}/>
      <Route path="/international/uganda/uganda_p6/uganda_p6math" element={<Uganda_p6math/>}/>
      <Route path="/international/uganda/uganda_p6/uganda_p6math/uganda_p6math_topics" element={<Uganda_p6math_topics/>}/>      
      <Route path="/international/uganda/uganda_p6/uganda_p6math/uganda_p6math_elements" element={<Uganda_p6math_elements/>}/>
      <Route path="/international/uganda/uganda_p6/uganda_p6math/uganda_p6math_form_subsets" element={<Uganda_p6math_form_subsets/>}/>
      <Route path="/international/uganda/uganda_p6/uganda_p6math/uganda_p6math_form_equal_sets" element={<Uganda_p6math_form_equal_sets/>}/>
      <Route path="/international/uganda/uganda_p6/uganda_p6math/uganda_p6math_form_complement_of_sets" element={<Uganda_p6math_form_complement_of_sets/>}/>
      <Route path="/international/uganda/uganda_p6/uganda_p6eng" element={<Uganda_p6eng/>}/>
      <Route path="/international/uganda/uganda_p6/uganda_p6scie" element={<Uganda_p6scie/>}/>
      <Route path="/international/uganda/uganda_p6/uganda_p6soc" element={<Uganda_p6soc/>}/>

      <Route path="/international/uganda/uganda_p7" element={<Uganda_p7/>}/>
      <Route path="/international/uganda/uganda_p7/uganda_p7math" element={<Uganda_p7math/>}/>
      <Route path="/international/uganda/uganda_p7/uganda_p7eng" element={<Uganda_p7eng/>}/>
      <Route path="/international/uganda/uganda_p7/uganda_p7scie" element={<Uganda_p7scie/>}/>
      <Route path="/international/uganda/uganda_p7/uganda_p7soc" element={<Uganda_p7soc/>}/>



       <Route path="/international/uganda/uganda_s1" element={<Uganda_s1/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1agr" element={<Uganda_s1agr/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1bio" element={<Uganda_s1bio/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1che" element={<Uganda_s1che/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1cre" element={<Uganda_s1cre/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1eng" element={<Uganda_s1eng/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1ent" element={<Uganda_s1ent/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1fin" element={<Uganda_s1fin/>}/>    
       <Route path="/international/uganda/uganda_s1/uganda_s1gen" element={<Uganda_s1gen/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1geo" element={<Uganda_s1geo/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1his" element={<Uganda_s1his/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1inf" element={<Uganda_s1inf/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1ire" element={<Uganda_s1ire/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1kis" element={<Uganda_s1kis/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1lit" element={<Uganda_s1lit/>}/>    
       <Route path="/international/uganda/uganda_s1/uganda_s1math" element={<Uganda_s1math/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1nut" element={<Uganda_s1nut/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1ped" element={<Uganda_s1ped/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1per" element={<Uganda_s1per/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1phy" element={<Uganda_s1phy/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1tec" element={<Uganda_s1tec/>}/>

       <Route path="/international/uganda/uganda_s1/uganda_s1fre" element={<Uganda_s1fre/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1ger" element={<Uganda_s1ger/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1chi" element={<Uganda_s1chi/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1lat" element={<Uganda_s1lat/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1ara" element={<Uganda_s1ara/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1lug" element={<Uganda_s1lug/>}/>
       <Route path="/international/uganda/uganda_s1/uganda_s1lus" element={<Uganda_s1lus/>}/>

       <Route path="/international/uganda/uganda_s2" element={<Uganda_s2/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2agr" element={<Uganda_s2agr/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2bio" element={<Uganda_s2bio/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2che" element={<Uganda_s2che/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2cre" element={<Uganda_s2cre/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2eng" element={<Uganda_s2eng/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2ent" element={<Uganda_s2ent/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2fin" element={<Uganda_s2fin/>}/>      
       <Route path="/international/uganda/uganda_s2/uganda_s2gen" element={<Uganda_s2gen/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2geo" element={<Uganda_s2geo/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2his" element={<Uganda_s2his/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2inf" element={<Uganda_s2inf/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2ire" element={<Uganda_s2ire/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2kis" element={<Uganda_s2kis/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2lit" element={<Uganda_s2lit/>}/>      
       <Route path="/international/uganda/uganda_s2/uganda_s2math" element={<Uganda_s2math/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2nut" element={<Uganda_s2nut/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2ped" element={<Uganda_s2ped/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2per" element={<Uganda_s2per/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2phy" element={<Uganda_s2phy/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2tec" element={<Uganda_s2tec/>}/>

       <Route path="/international/uganda/uganda_s2/uganda_s2fre" element={<Uganda_s2fre/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2ger" element={<Uganda_s2ger/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2chi" element={<Uganda_s2chi/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2lat" element={<Uganda_s2lat/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2ara" element={<Uganda_s2ara/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2lug" element={<Uganda_s2lug/>}/>
       <Route path="/international/uganda/uganda_s2/uganda_s2lus" element={<Uganda_s2lus/>}/>

       <Route path="/international/uganda/uganda_s3" element={<Uganda_s3/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3agr" element={<Uganda_s3agr/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3bio" element={<Uganda_s3bio/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3che" element={<Uganda_s3che/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3cre" element={<Uganda_s3cre/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3eng" element={<Uganda_s3eng/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3ent" element={<Uganda_s3ent/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3fin" element={<Uganda_s3fin/>}/>     
       <Route path="/international/uganda/uganda_s3/uganda_s3gen" element={<Uganda_s3gen/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3geo" element={<Uganda_s3geo/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3his" element={<Uganda_s3his/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3inf" element={<Uganda_s3inf/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3ire" element={<Uganda_s3ire/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3kis" element={<Uganda_s3kis/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3lit" element={<Uganda_s3lit/>}/>      
       <Route path="/international/uganda/uganda_s3/uganda_s3math" element={<Uganda_s3math/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3nut" element={<Uganda_s3nut/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3ped" element={<Uganda_s3ped/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3per" element={<Uganda_s3per/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3phy" element={<Uganda_s3phy/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3tec" element={<Uganda_s3tec/>}/>

       <Route path="/international/uganda/uganda_s3/uganda_s3fre" element={<Uganda_s3fre/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3ger" element={<Uganda_s3ger/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3chi" element={<Uganda_s3chi/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3lat" element={<Uganda_s3lat/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3ara" element={<Uganda_s3ara/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3lug" element={<Uganda_s3lug/>}/>
       <Route path="/international/uganda/uganda_s3/uganda_s3lus" element={<Uganda_s3lus/>}/>

       <Route path="/international/uganda/uganda_s4" element={<Uganda_s4/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4agr" element={<Uganda_s4agr/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4bio" element={<Uganda_s4bio/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4che" element={<Uganda_s4che/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4cre" element={<Uganda_s4cre/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4eng" element={<Uganda_s4eng/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4ent" element={<Uganda_s4ent/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4fin" element={<Uganda_s4fin/>}/>   
       <Route path="/international/uganda/uganda_s4/uganda_s4gen" element={<Uganda_s4gen/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4geo" element={<Uganda_s4geo/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4his" element={<Uganda_s4his/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4inf" element={<Uganda_s4inf/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4ire" element={<Uganda_s4ire/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4kis" element={<Uganda_s4kis/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4lit" element={<Uganda_s4lit/>}/>      
       <Route path="/international/uganda/uganda_s4/uganda_s4math" element={<Uganda_s4math/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4nut" element={<Uganda_s4nut/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4ped" element={<Uganda_s4ped/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4per" element={<Uganda_s4per/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4phy" element={<Uganda_s4phy/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4tec" element={<Uganda_s4tec/>}/>

       <Route path="/international/uganda/uganda_s4/uganda_s4fre" element={<Uganda_s4fre/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4ger" element={<Uganda_s4ger/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4chi" element={<Uganda_s4chi/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4lat" element={<Uganda_s4lat/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4ara" element={<Uganda_s4ara/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4lug" element={<Uganda_s4lug/>}/>
       <Route path="/international/uganda/uganda_s4/uganda_s4lus" element={<Uganda_s4lus/>}/>

       <Route path="/international/uganda/uganda_s5" element={<Uganda_s5/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5agr" element={<Uganda_s5agr/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5bio" element={<Uganda_s5bio/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5che" element={<Uganda_s5che/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5cre" element={<Uganda_s5cre/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5eco" element={<Uganda_s5eco/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5ent" element={<Uganda_s5ent/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5fin" element={<Uganda_s5fin/>}/>      
       <Route path="/international/uganda/uganda_s5/uganda_s5geo" element={<Uganda_s5geo/>}/>        
       <Route path="/international/uganda/uganda_s5/uganda_s5gep" element={<Uganda_s5gep/>}/>       
       <Route path="/international/uganda/uganda_s5/uganda_s5his" element={<Uganda_s5his/>}/>       
       <Route path="/international/uganda/uganda_s5/uganda_s5ire" element={<Uganda_s5ire/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5kis" element={<Uganda_s5kis/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5lit" element={<Uganda_s5lit/>}/>      
       <Route path="/international/uganda/uganda_s5/uganda_s5math" element={<Uganda_s5math/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5nut" element={<Uganda_s5nut/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5ped" element={<Uganda_s5ped/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5per" element={<Uganda_s5per/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5phy" element={<Uganda_s5phy/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5scom" element={<Uganda_s5scom/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5smath" element={<Uganda_s5smath/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5tec" element={<Uganda_s5tec/>}/>

       <Route path="/international/uganda/uganda_s5/uganda_s5fre" element={<Uganda_s5fre/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5ger" element={<Uganda_s5ger/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5chi" element={<Uganda_s5chi/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5lat" element={<Uganda_s5lat/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5ara" element={<Uganda_s5ara/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5lug" element={<Uganda_s5lug/>}/>
       <Route path="/international/uganda/uganda_s5/uganda_s5lus" element={<Uganda_s5lus/>}/>

       <Route path="/international/uganda/uganda_s6" element={<Uganda_s6/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6agr" element={<Uganda_s6agr/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6bio" element={<Uganda_s6bio/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6che" element={<Uganda_s6che/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6cre" element={<Uganda_s6cre/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6eco" element={<Uganda_s6eco/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6ent" element={<Uganda_s6ent/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6fin" element={<Uganda_s6fin/>}/>    
       <Route path="/international/uganda/uganda_s6/uganda_s6geo" element={<Uganda_s6geo/>}/>        
       <Route path="/international/uganda/uganda_s6/uganda_s6gep" element={<Uganda_s6gep/>}/>       
       <Route path="/international/uganda/uganda_s6/uganda_s6his" element={<Uganda_s6his/>}/>       
       <Route path="/international/uganda/uganda_s6/uganda_s6ire" element={<Uganda_s6ire/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6kis" element={<Uganda_s6kis/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6lit" element={<Uganda_s6lit/>}/>      
       <Route path="/international/uganda/uganda_s6/uganda_s6math" element={<Uganda_s6math/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6nut" element={<Uganda_s6nut/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6ped" element={<Uganda_s6ped/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6per" element={<Uganda_s6per/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6phy" element={<Uganda_s6phy/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6scom" element={<Uganda_s6scom/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6smath" element={<Uganda_s6smath/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6tec" element={<Uganda_s6tec/>}/>

       <Route path="/international/uganda/uganda_s6/uganda_s6fre" element={<Uganda_s6fre/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6ger" element={<Uganda_s6ger/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6chi" element={<Uganda_s6chi/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6lat" element={<Uganda_s6lat/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6ara" element={<Uganda_s6ara/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6lug" element={<Uganda_s6lug/>}/>
       <Route path="/international/uganda/uganda_s6/uganda_s6lus" element={<Uganda_s6lus/>}/>
        </Route>
      </Routes>
      </Router>
   
    </div>

  );
};

const App = () => {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
};

export default App;



const AdminRouteGuard = ({ currentUser }) => {
  // If the authentication context is loading, you can render a fallback spinner here
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but the role is wrong, block them
  if (currentUser.role !== 'admin') {
    return <Navigate to="/login" replace />;
  }

  // If they pass checks, render the matched child route
  return <Outlet />;
};



